import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { supabase }          from './lib/supabase'
import { useRole }           from './lib/roles'
import { useIdleTimeout }    from './lib/useIdleTimeout'
import Login                 from './pages/Login'
import Dashboard             from './pages/Dashboard'
import Agents                from './pages/Agents'
import Scoring               from './pages/Scoring'
import Infractions           from './pages/Infractions'
import ComplianceReview      from './pages/ComplianceReview'
import Reports               from './pages/Reports'
import Settings              from './pages/Settings'
import TargetBoard           from './pages/TargetBoard'
import TargetSettings        from './pages/TargetSettings'
import Enforcement           from './pages/Enforcement'
import Layout                from './components/Layout'
import PublicTargets         from './pages/PublicTargets'

function ProtectedRoute({ session, children }) {
  if (!session) return <Navigate to="/login" replace />
  return children
}

function AppRoutes({ session, setSession }) {
  const roleCtx = useRole(session)

  // Idle timeout: 30 min no activity → sign out
  // Visibility: away 15+ min → reload for fresh data
  useIdleTimeout(session)

  if (roleCtx.loading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
        height:'100vh', fontFamily:'Montserrat,sans-serif', color:'#8b949e', fontSize:13 }}>
        Loading…
      </div>
    )
  }

  return (
    <Routes>
      <Route path="/login" element={session ? <Navigate to="/" replace /> : <Login setSession={setSession} />} />
      <Route path="/targets" element={<PublicTargets />} />
      <Route path="/" element={
        <ProtectedRoute session={session}>
          <Layout session={session} setSession={setSession} roleCtx={roleCtx} />
        </ProtectedRoute>
      }>
        <Route index                   element={<Dashboard        session={session} roleCtx={roleCtx} />} />
        <Route path="agents"           element={<Agents           session={session} roleCtx={roleCtx} />} />
        <Route path="scoring"          element={<Scoring          session={session} roleCtx={roleCtx} />} />
        <Route path="target-board"     element={<TargetBoard      session={session} roleCtx={roleCtx} />} />
        <Route path="target-settings"  element={<TargetSettings   session={session} roleCtx={roleCtx} />} />
        <Route path="infractions"      element={<Infractions      session={session} roleCtx={roleCtx} />} />
        <Route path="compliance"       element={<ComplianceReview session={session} roleCtx={roleCtx} />} />
        <Route path="enforcement"      element={<Enforcement      session={session} roleCtx={roleCtx} />} />
        <Route path="reports"          element={<Reports          session={session} roleCtx={roleCtx} />} />
        <Route path="settings"         element={<Settings         session={session} roleCtx={roleCtx} />} />
      </Route>
    </Routes>
  )
}

export default function App() {
  const [session, setSession] = useState(undefined)

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session))
    const { data: listener } = supabase.auth.onAuthStateChange((_e, s) => setSession(s))
    return () => listener.subscription.unsubscribe()
  }, [])

  if (session === undefined) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
        height:'100vh', fontFamily:'Montserrat,sans-serif', color:'#8b949e', fontSize:13 }}>
        Loading…
      </div>
    )
  }

  return (
    <BrowserRouter>
      <AppRoutes session={session} setSession={setSession} />
    </BrowserRouter>
  )
}
